import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldOpen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 31 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16 3.125L4.5625 7.9375C4.1875 8.125 3.9375 8.4375 4 8.75C4 14.5 6.375 24.375 15.625 28.75C15.875 28.875 16.125 28.875 16.3125 28.75C25.5625 24.3125 27.9375 14.5 28 8.75C28 8.4375 27.75 8.125 27.4375 7.9375L16 3.125ZM16.8125 0.1875L28.5625 5.1875C29.9375 5.8125 31 7.125 31 8.75C30.9375 15 28.375 26.3125 17.625 31.5C16.5625 32 15.375 32 14.3125 31.5C3.5625 26.3125 1 15 1 8.75C0.9375 7.125 2 5.8125 3.375 5.1875L15.125 0.1875C15.375 0.0625 15.6875 0 16 0C16.25 0 16.5625 0.0625 16.8125 0.1875Z",
		fill: "#D1B278"
	})]
});
const ForwardRef = forwardRef(SvgIconShieldOpen);
export { ForwardRef as ReactComponent };
